export const create = {
  form: {
    name: '部品名',
    totalTimeUsed: '洗浄耐用回数',
    totalLife: 'アラート回数',
    submit: '新規追加',
    timeUnit: '回',
    addMoreMachineComponent: '洗濯機部品追加',
    requireServiceLife: '機械部品の耐用年数を入力してください',
    requireName: '機械部品の名前を入力してください',
  },
  pageHeader: {
    title: '水洗機リスト　新規追加画面',
    back: '戻る',
  },
}
